import React, { useRef, useEffect, useCallback } from 'react';
import tapeAuth from '../../assets/valentinesDay/tapeAuth.svg';
import tapeAuthMobile from '../../assets/valentinesDay/tapeAuthMobile.svg';

const AnimatedTapeAuth = () => {
  const desktopRef = useRef(null);
  const mobileRef = useRef(null);
  const pauseTimerRef = useRef(null);

  const pauseAnimation = useCallback(() => {
    desktopRef.current?.classList.add('is-paused');
    mobileRef.current?.classList.add('is-paused');

    if (pauseTimerRef.current) {
      clearTimeout(pauseTimerRef.current);
    }

    pauseTimerRef.current = setTimeout(() => {
      desktopRef.current?.classList.remove('is-paused');
      mobileRef.current?.classList.remove('is-paused');
    }, 400);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', pauseAnimation, { passive: true });
    window.addEventListener('touchstart', pauseAnimation, { passive: true });
    window.addEventListener('touchmove', pauseAnimation, { passive: true });

    return () => {
      window.removeEventListener('scroll', pauseAnimation);
      window.removeEventListener('touchstart', pauseAnimation);
      window.removeEventListener('touchmove', pauseAnimation);
      if (pauseTimerRef.current) {
        clearTimeout(pauseTimerRef.current);
      }
    };
  }, [pauseAnimation]);

  return (
    <>
      <div
        ref={desktopRef}
        className="valentines-tape-auth valentines-tape-auth-desktop"
        aria-hidden="true"
      >
        <div className="valentines-tape-auth-track">
          <img src={tapeAuth} alt="" className="valentines-tape-img" />
          <img src={tapeAuth} alt="" className="valentines-tape-img" />
        </div>
      </div>
      <div
        ref={mobileRef}
        className="valentines-tape-auth valentines-tape-auth-mobile"
        aria-hidden="true"
      >
        <div className="valentines-tape-auth-track valentines-tape-auth-track-mobile">
          <img src={tapeAuthMobile} alt="" className="valentines-tape-img" />
          <img src={tapeAuthMobile} alt="" className="valentines-tape-img" />
          <img src={tapeAuthMobile} alt="" className="valentines-tape-img" />
        </div>
      </div>
    </>
  );
};

export default AnimatedTapeAuth;
